import { createSelector } from "@reduxjs/toolkit";
import { initialState, type CreateAccountState } from "./slice";

const createAccountInitialState = (state: {
  createAccount?: CreateAccountState;
}): CreateAccountState => state.createAccount || initialState;

export const selectSignup = createSelector(
  [createAccountInitialState],
  (state) => state.signup,
);

export const selectCredentials = createSelector(
  [createAccountInitialState],
  (state) => state.credentials,
);

export const selectVerifySignupOtp = createSelector(
  [createAccountInitialState],
  (state) => state.verifyOtp,
);

export const selectResendSignupOtp = createSelector(
  [createAccountInitialState],
  (state) => state.resendOtp,
);
